import { http } from '../../../../api/http';
import type { DescansoMedico, ResumenAnualDescanso } from '../types/descansoMedico';

const ENDPOINT = '/planilla/descanso-medico';

export class DescansoMedicoService {
  static async getByPeriodo(idPeriodo: number, idTrabajador?: number): Promise<DescansoMedico[]> {
    const params: Record<string, number> = {};
    if (idTrabajador) params.idTrabajador = idTrabajador;
    const response = await http.get(`${ENDPOINT}/periodo/${idPeriodo}`, { params });
    return response.data;
  }

  static async getByTrabajador(idTrabajador: number): Promise<DescansoMedico[]> {
    const response = await http.get(`${ENDPOINT}/trabajador/${idTrabajador}`);
    return response.data;
  }

  static async getById(id: number): Promise<DescansoMedico> {
    const response = await http.get(`${ENDPOINT}/${id}`);
    return response.data;
  }

  static async create(descanso: Partial<DescansoMedico>): Promise<DescansoMedico> {
    const response = await http.post(ENDPOINT, descanso);
    return response.data;
  }

  static async update(id: number, descanso: Partial<DescansoMedico>): Promise<DescansoMedico> {
    const response = await http.put(`${ENDPOINT}/${id}`, descanso);
    return response.data;
  }

  static async delete(id: number): Promise<void> {
    await http.delete(`${ENDPOINT}/${id}`);
  }

  static async getResumenAnual(idTrabajador: number, anio: number): Promise<ResumenAnualDescanso> {
    const response = await http.get(`${ENDPOINT}/resumen-anual/${idTrabajador}/${anio}`);
    return response.data;
  }
}
